import { adStateEnum, AdUnitEventName } from '../../../@types/vpaid.type';
import { AdUnitEventListener } from './vpaid-ad-unit-event-listener';

export class AdUnitStateManager {
  _adState: string = adStateEnum.IDLE;

  _events: {
    [eventName: string]: string;
  } = {
    AdLoaded: adStateEnum.LOADED,
    AdStarted: adStateEnum.STARTED,
    AdVideoComplete: adStateEnum.COMPLETED,
    AdStopped: adStateEnum.STOPPED,
    AdPaused: adStateEnum.PAUSED,
    AdPlaying: adStateEnum.STARTED,
    AdError: adStateEnum.ERROR
  };

  constructor(adUnitEventListener: AdUnitEventListener) {
    this._subscribeEvents(adUnitEventListener);
  }

  getState(): string {
    return this._adState;
  }

  _subscribeEvents(eventManager: AdUnitEventListener): void {
    for (const eventName in this._events) {
      eventManager.addEventListener(
        eventName as AdUnitEventName,
        (() => {
          this._transitionState(eventName as AdUnitEventName);
        }).bind(this)
      );
    }
  }

  _transitionState(eventName: AdUnitEventName): void {
    const newState = this._events[eventName];

    if (!newState) {
      return;
    }

    this._adState = newState;
  }
}
